const $masthead = $('.masthead'),
    classMastheadSticky = 'masthead--fixed';

let stickyTreshold = $masthead.offset().top;

$(window).on('resize', function () {
    stickyTreshold = $masthead.offset().top;
});

window.addEventListener('scroll', function () {
    let scrolledDistance = window.scrollY;

    if (scrolledDistance > stickyTreshold) {
        if (!$masthead.hasClass(classMastheadSticky)) {
            $masthead.addClass(classMastheadSticky);
        }
    } else {
        if ($masthead.hasClass(classMastheadSticky)) {
            $masthead.removeClass(classMastheadSticky);
        }
    }
});
